import i18n from "../i18n/i18n";
import { useTranslation } from "react-i18next";
import { I18nextProvider } from "react-i18next";
import { createContext, useContext, useEffect, useMemo } from "react";

// I18Context to keep the latest state
const I18Context = createContext(null);

// useI18Context to share this components state everywhere this component is imported
export const useI18Context = () => {
  const context = useContext(I18Context);

  if (!context) throw new Error("useI18Context context must be use inside I18Provider");

  return context;
};

export default function I18Provider({ children, lang = "" }) {
  const { t } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang]);

  const memoizedValue = useMemo(() => ({ t, i18n, lang }), [t, lang]);

  return (
    <I18Context.Provider value={memoizedValue}>
      <I18nextProvider i18n={i18n} defaultNS={"translation"}>
        {children}
      </I18nextProvider>
    </I18Context.Provider>
  );
}
